import React from 'react';
import { cdn } from '../../helpers/cdn';
import injectSheet from 'react-jss';
import PropTypes from 'prop-types';

const propTypes = {
    classes: PropTypes.object.isRequired,
    type: PropTypes.string.isRequired,
    size: PropTypes.string
};

const iconsMap = {
    error: 'icons/server-error-icon.svg',
    empty: 'icons/no-data-icon.svg',
};

const Icon = ({classes, type, size = 'normal'}) => {
    const iconSrc = cdn(iconsMap[type]);

    return (
        <div className={classes[size]}>
            <img src={iconSrc} />
        </div>
    );
};

const styles = theme => ( {
    normal: {
        height: '100%',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }
} );

Icon.propTypes = propTypes;

export default injectSheet(styles)(Icon);




// WEBPACK FOOTER //
// ./src/app/components/icon/Icon.js